import type { Reviews } from '@sravni/react-seo';
import type { ComponentProps } from 'react';

import type { TReview } from 'shared/types/TReviewsService';

export const mapReviews = (review: TReview): ComponentProps<typeof Reviews>['reviews'][number] => {
  const { rating, ...reviewData } = review;

  return {
    ...reviewData,
    ...(rating ? { rating } : {}),
  };
};
